module.exports = __webpack_public_path__ + "static/desktop_recruit_page_visual-4e6f203605f32158a9973e4a677ca9a2.png";